import { BEmbed } from './embed';
import { pluginFactory } from '../../utils/plugins';
var EmbedPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BEmbed: BEmbed
  }
});
export { EmbedPlugin, BEmbed };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/embed/index.js
// module id = XkGH
// module chunks = 5